import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { SponsoredPropertiesCarousel, useSponsoredPropertiesContext } from '@shared-ui/retail-lodging-sponsored-properties-carousel';

import { adaptSearchCriteria } from 'src/common/stores/adapters/bex-api/common/search-criteria-adapter';
import { CurrentHotelStore } from 'stores/current-hotel-store';
import { getShoppingContextInput } from 'src/common/stores/adapters';
import { MultiItemStore } from 'src/common/stores/multi-item-store';
import { PropertySort } from 'stores/models/search-criteria-model';
import { usePlatformContext } from 'src/common/stores/contexts/platformContext';
import { useSearchCriteriaContext } from 'src/common/stores/contexts';
import CarouselContext from 'src/common/stores/contexts/carousel-context-provider';

import { ADS_ONLY_SELECTION } from 'constants/ads';

import { UitkSpacing } from 'uitk-react-spacing';

import PropertyRecsVariantWrapper from '../similar-hotels/property-recs-variant-wrapper';

interface PropertyTopCarouselWrapperProps {
  currentHotel?: CurrentHotelStore;
  multiItem?: MultiItemStore;
}

export const PropertyTopCarouselWrapper: React.FunctionComponent<PropertyTopCarouselWrapperProps> = inject(
  'currentHotel',
  'multiItem'
)(
  observer(props => {
    const context = usePlatformContext();
    const searchCriteria = useSearchCriteriaContext();
    const multiItemContext = props.multiItem?.multiItemContext;
    const shoppingContext = getShoppingContextInput(multiItemContext);
    const propertySearchCriteriaNonAds = adaptSearchCriteria(context, searchCriteria);
    const propertySearchCriteriaAds = adaptSearchCriteria(context, searchCriteria, undefined, ADS_ONLY_SELECTION);
    propertySearchCriteriaAds.primary.destination.pinnedPropertyId = `${props.currentHotel?.hotelId ?? ''}`;
    const { addTopCarouselName } = React.useContext(CarouselContext);
    const { isProperties } = useSponsoredPropertiesContext();

    React.useEffect(() => {
      if (isProperties) {
        addTopCarouselName('travel-ads');
      }
    }, [isProperties]);

    const canShowSponsoredCarousel = searchCriteria.sort === PropertySort.RECOMMENDED;

    return (
      <>
        {canShowSponsoredCarousel && (
          <UitkSpacing margin={{ inline: 'three' }}>
            <div data-stid="sponsored-properties-carousel">
              <SponsoredPropertiesCarousel
                inputs={{ criteria: propertySearchCriteriaAds, shoppingContext: shoppingContext }}
                skipSsr={true}
              />
            </div>
          </UitkSpacing>
        )}
        {!isProperties && (
          <PropertyRecsVariantWrapper
            propertyId={String(props.currentHotel?.hotelId)}
            propertySearchCriteriaInput={propertySearchCriteriaNonAds}
            shoppingContext={shoppingContext}
          />
        )}
      </>
    );
  })
);
